// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:04:41

export default {
  "id": "jailbreak-cube-jumper",
  "slug": "jailbreak-cube-jumper",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/bfb0d572f25c4ab6874b350d5c340815-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/bfb0d572f25c4ab6874b350d5c340815/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Jailbreak. Roblox jumper",
      "description": "In this thrilling game with a cubic style, the character attempts to escape from prison by progressing through levels, each represented as a separate platform. On each level, you'll need to collect coins that help speed up your escape, but be careful: dangerous traps and obstacles await at every turn. A wrong move or misstep could cost you your life. Navigate through each level, avoid the threats, and move closer to freedom!",
      "instructions": "PC: WSAD or Arrows.\nMobile: Swipes.\nTablet: Swipes.",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "1player",
        "3d",
        "arcade",
        "escape",
        "roblox"
      ]
    },
    "zh-CN": {
      "title": "越狱。Roblox 跳跃者",
      "description": "在这款充满刺激的立方风格游戏中，角色试图通过完成各个关卡来逃离监狱，每个关卡都代表一个独立平台。在每一关中，你需要收集硬币来加速逃脱，但要注意：危险陷阱和障碍在每一个角落等待着你。一个错误的动作或失误可能会让你丧命。穿越每一关，避开威胁，向自由迈进！",
      "instructions": "PC: WSAD 或 方向键。\n移动设备：滑动操作。\n平板电脑：滑动操作。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "1玩家",
        "3D",
        "街机",
        "逃脱",
        "Roblox"
      ]
    },
    "zh-TW": {
      "title": "金錢解放。羅布樂堡跳躍者",
      "description": "在這款充滿刺激的立體風格遊戲中，角色嘗試通過進行各級別的挑戰來逃離監獄，每個級別都代表一個獨立的平台。在每個級別中，你都需要收集幫助加速逃離的硬幣，但請小心：危險的陷阱和障礙隨處可見。一個錯誤的動作或失誤可能會讓你付出生命代價。通過每個級別，避免威脅，並向自由靠近！",
      "instructions": "PC：WSAD 或 方向鍵。\n行動裝置：滑動。\n平板電腦：滑動。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "1人玩家",
        "3D",
        "街機",
        "逃離",
        "Roblox"
      ]
    },
    "zh-HK": {
      "title": "獄監破壞者。Roblox 跳躍者",
      "description": "在這款充滿刺激的立體風格遊戲中，角色試圖透過通過各個等級來逃離監獄，每個等級都象徵著一個獨立的平台。在每個等級中，你需要收集幫助你加速逃離的硬幣，但請小心：危險的陷阱和障礙在每個轉角都等待著你。一個錯誤的動作或失誤可能會讓你失去生命。通過每個等級，避開威脅，並逐漸接近自由！",
      "instructions": "PC: WSAD 或 方向鍵。\n手機: 滑動。\n平板電腦: 滑動。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "1人遊戲",
        "3D",
        "街機",
        "逃離",
        "Roblox"
      ]
    },
    "ja": {
      "title": "ジャイルブレイク。ロブロックスジャンパー",
      "description": "この迫力ある立方体スタイルのゲームで、キャラクターはレベルを進めることで刑務所から脱出しようとします。それぞれのレベルは独立したプラットフォームで表されます。各レベルでは、脱出を加速させるためにコインを集める必要がありますが、気をつけてください：危険な罠や障害が手がかりのように待ち受けています。間違った行動や誤歩で命を落とすかもしれません。レベルを進み、脅威を避け、自由に近づいていきましょう！",
      "instructions": "PC: WSADまたは矢印キー。\nモバイル: スワイプ。\nタブレット: スワイプ。",
      "genres": [
        "冒険"
      ],
      "tags": [
        "1プレイヤー",
        "3D",
        "アーケード",
        "エスケープ",
        "ロブロックス"
      ]
    },
    "ko": {
      "title": "제일벽 깨기. Roblox 점프자",
      "description": "이 캐릭터가 3차원 스타일의 흥미진진한 게임에서, 각 단계가 별도의 플랫폼으로 표현된 감옥을 탈출하려고 시도합니다. 각 단계에서는 도망칠 데 도움이 되는 동전을 모으아야 하지만 주의하세요: 위험한 사냥場과 장애물이 각角落에 있습니다. 잘못된 움직임이나 실수로는 생명을 잃을 수 있습니다. 각 단계를 돌아다니며 위협을 피하고 자유로운 길로 접근하세요!",
      "instructions": "PC: WSAD 또는 화살표.\n모바일: 스와이프.\n태블릿: 스와이프.",
      "genres": [
        "모험"
      ],
      "tags": [
        "1플레이어",
        "3D",
        "아케이드",
        "탈출",
        "로빅스"
      ]
    },
    "fr": {
      "title": "Jailbreak. Sauter sur Roblox",
      "description": "Dans ce jeu captivant aux graphismes cubiques, le personnage tente de s'échapper de prison en progressant à travers des niveaux, chacun représenté par une plateforme distincte. Sur chaque niveau, vous devrez collecter des pièces qui aident à accélérer votre fuite, mais attention : des pièges et des obstacles dangereux attendent à chaque coin de route. Un mauvais coup ou une erreur pourrait vous coûter la vie. Navigatez à travers chaque niveau, évitez les menaces et approchez-vous de la liberté !",
      "instructions": "PC : WSAD ou Flèches.\nMobile : Glissements.\nTablette : Glissements.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "1 joueur",
        "3D",
        "arcade",
        "évasion",
        "Roblox"
      ]
    }
  }
};
